/* global google */

import { Loader } from 'google-maps';
import createMapsMarkers from './createMapsMarker';

const maps = document.querySelectorAll('.js-map');
const mapsArray = Array.prototype.slice.call(maps);

// Google Maps API key
const KEY = 'AIzaSyCPoDTw6HW9qJwfOfVdU3A77FL4x91vdjw';

// Style array for custom colored maps
const STYLE = [{featureType:"administrative.locality",elementType:"all",stylers:[{hue:"#2c2e33"},{saturation:7},{lightness:19},{visibility:"on"}]},{featureType:"landscape",elementType:"all",stylers:[{hue:"#ffffff"},{saturation:-100},{lightness:100},{visibility:"simplified"}]},{featureType:"poi",elementType:"all",stylers:[{hue:"#ffffff"},{saturation:-100},{lightness:100},{visibility:"off"}]},{featureType:"road",elementType:"geometry",stylers:[{hue:"#bbc0c4"},{saturation:-93},{lightness:31},{visibility:"simplified"}]},{featureType:"road",elementType:"labels",stylers:[{hue:"#bbc0c4"},{saturation:-93},{lightness:31},{visibility:"on"}]},{featureType:"road.arterial",elementType:"labels",stylers:[{hue:"#bbc0c4"},{saturation:-93},{lightness:-2},{visibility:"simplified"}]},{featureType:"road.local",elementType:"geometry",stylers:[{hue:"#e9ebed"},{saturation:-90},{lightness:-8},{visibility:"simplified"}]},{featureType:"transit",elementType:"all",stylers:[{hue:"#e9ebed"},{saturation:10},{lightness:69},{visibility:"on"}]},{featureType:"water",elementType:"all",stylers:[{hue:"#e9ebed"},{saturation:-78},{lightness:67},{visibility:"simplified"}]}]; // eslint-disable-line

const DEFAULT_OPTIONS = {
  disableDoubleClickZoom: true,
  scrollwheel: false,
  navigationControl: false,
  mapTypeControl: false,
  scaleControl: false,
  draggable: false,
  streetViewControl: false,
  fullscreenControl: false,
};

const map = {
  initialize(el) {
    this.el = el;

    this.el.classList.add('is-loading');

    // Shortcut to all data attributes
    this.data = this.el.dataset;

    this.validateOptions(this.data);

    // Validate and retrieve geolocation
    const geo = this.data.geo.split(',');

    const latLng = {
      lat: parseFloat(geo[0]),
      lng: parseFloat(geo[1]),
    };

    // Validate and retrieve zoom
    const zoom = parseInt(this.data.zoom, 10);

    const mapObj = this.createMap(latLng, zoom);

    this.el.classList.remove('is-loading');

    if (typeof this.data.markerGeo !== 'undefined') {
      // Get the marker geo location
      const markerGeo = this.data.markerGeo.split(',');

      createMapsMarkers(
        markerGeo[0],
        markerGeo[1],
        this.data.markerIcon,
        this.data.markerSize,
        this.data.markerAnchor,
        this.data.markerTitle,
        mapObj,
      );
    }
  },

  validateOptions(dataObj) {
    const validations = {
      geo: 'No data-geo defined on the map element',
      zoom: 'No data-zoom defined on the map element',
    };

    const dataKeys = Object.keys(dataObj);

    Object.keys(validations).forEach((validation) => {
      const errMsg = validations[validation];

      if (dataKeys.indexOf(validation) < 0) {
        throw new Error(errMsg);
      }
    });
  },

  /**
   * Create a map
   * @return {Object} Google Maps object
   */
  createMap(center, zoom) {
    // Create Google map
    const style = {
      center,
      zoom,
      styles: STYLE,
    };

    return new google.maps.Map(this.el, { ...DEFAULT_OPTIONS, ...style });
  },
};

export default {
  initialize() {
    if (!mapsArray.length) { return; }

    const loader = new Loader(KEY);

    loader.load().then(() => {
      mapsArray.forEach((mapEl) => {
        const mapInst = { ...map };
        mapInst.initialize(mapEl);
      });
    });
  },
};
